import useSWR from 'swr';
// import useUserTotalDeposits from './useUserTotalDeposits';
import useMockUserTotalDeposits from './useMockUserTotalDeposits';
// import useUserTotalWithdrawals from './useUserTotalWithdrawals';
import useMockUserTotalWithdrawals from './useMockUserTotalWithdrawals';
import { formatEther, formatUnits, parseEther, parseUnits } from 'ethers/lib/utils';
import { toBigNumber } from '../../../web3/utils';
import useLiquidityPools from './useLiquidityPools';

const useUserPoolPnl = () => {
    const { liquidityPools } = useLiquidityPools();
    // const { userTotalDeposits } = useUserTotalDeposits();
    const { userTotalDeposits } = useMockUserTotalDeposits();
    // const { userTotalWithdrawals } = useUserTotalWithdrawals();
    const { userTotalWithdrawals } = useMockUserTotalWithdrawals();

    const { data, error, mutate } = useSWR(
        liquidityPools && userTotalDeposits && userTotalWithdrawals
            ? ['userPoolPnl', liquidityPools, userTotalDeposits, userTotalWithdrawals]
            : null,
        (_, liquidityPools, userTotalDeposits, userTotalWithdrawals) => {
            let totalPnlAllPools = '0';
            let finalTotalPnlPercentage = '0';

            const userPnls = liquidityPools.map((liquidityPool) => {
                // looping across all 3 liiquidity pools - bluechip / altcoin / degen

                const shareDecimals = liquidityPool.decimals;

                let userPnlPerPool = '0';
                let userPnlPercentagePerPool = '0';

                const userTotalDepositPerPool =
                    userTotalDeposits.totalDepositsPerPool.find(
                        ({ liquidityPool: userLiquidityPool }) =>
                            userLiquidityPool.poolId.toLowerCase() ===
                            liquidityPool.poolId.toLowerCase()
                    );
                const userTotalWithdrawPerPool =
                    userTotalWithdrawals.totalWithdrawalsPerPool.find(
                        ({ liquidityPool: userLiquidityPool }) =>
                            userLiquidityPool.poolId.toLowerCase() ===
                            liquidityPool.poolId.toLowerCase()
                    );

                if (userTotalDepositPerPool && userTotalWithdrawPerPool) {
                    const totalSubgraphDepositAssetPerPool = parseUnits(
                        userTotalDepositPerPool.totalSubgraphDepositAsset,
                        shareDecimals
                    );

                    const totalSubgraphWithdrawnAssetPerPool = parseUnits(
                        userTotalWithdrawPerPool.totalAssetWithdrawn,
                        shareDecimals
                    );

                    userPnlPerPool = formatUnits(
                        parseUnits(userTotalDepositPerPool.totalAssets, shareDecimals)
                            .add(totalSubgraphWithdrawnAssetPerPool)
                            .sub(totalSubgraphDepositAssetPerPool),
                        shareDecimals
                    );

                    totalPnlAllPools = formatUnits(
                        parseUnits(totalPnlAllPools, shareDecimals).add(
                            parseUnits(userPnlPerPool, shareDecimals)
                        ),
                        shareDecimals
                    );

                    if (!totalSubgraphDepositAssetPerPool.isZero()) {
                        userPnlPercentagePerPool = formatUnits(
                            parseUnits(userPnlPerPool, shareDecimals)
                                .mul(parseUnits('100', shareDecimals))
                                .div(totalSubgraphDepositAssetPerPool),
                            shareDecimals
                        );
                    }
                }

                return {
                    liquidityPool,
                    pnlPerPool: userPnlPerPool,
                    pnlPercentagePerPool: userPnlPercentagePerPool,
                };
            });

            if (!toBigNumber(userTotalDeposits.totalDepositAssetAllPools).isZero()) {
                finalTotalPnlPercentage = formatEther(
                    parseEther(totalPnlAllPools)
                        .mul(parseEther('100'))
                        .div(toBigNumber(userTotalDeposits.totalDepositAssetAllPools))
                );
            }

            return {
                userPoolPnl: userPnls,
                finalTotalPnl: totalPnlAllPools,
                finalTotalPnlPercentage,
            };
        }
    );

    return {
        userPoolPnl: data,
        isLoading: !data && !error,
        error,
        updateUserPoolPnl: mutate,
    };
};

export default useUserPoolPnl;
